module.exports = __webpack_public_path__ + "static/media/logo.04e09dee.svg";